import { Box, Button, Dialog, DialogContent, Grid, InputAdornment, List, ListItem, MenuItem, Stack, TextField, Typography } from '@mui/material'
import React, { useCallback } from 'react'
import styles from '../../styles/components/qc-notification-filter.module.scss'
import TableFilterIcon from '../../ui/Icons/TableFilterIcon'
import SearchIcon from '../../public/assets/images/icon-gray-search.svg'
import icongrayCross from '../../public/assets/images/icon-sm-cross.svg'
import { Link } from 'react-router-dom'
import SelectMonth from '../../ui/Customdropdown/SelectMonth'
import SelectDay from '../../ui/Customdropdown/SelectDay'
import SelectYear from '../../ui/Customdropdown/SelectYear'
import ClearIcon from '../../ui/Icons/ClearIcon'
import ResetIcon from '../../ui/Icons/ResetIcon'
import CustomSelect from '../../ui/Customdropdown/CustomSelect'
import CustomCheckBox from '../../ui/Inputs/CustomCheckBox'

const dialogContainer = {
    [`.MuiDialog-container`]: {
        alignItems: "flex-start",

        [`.MuiDialog-paper`]: {
            marginTop: "72px",
            boxShadow: "none",
            borderRadius: "10px !important",
            [`.MuiDialogContent-root`]: {
                padding: "0 11px"
            }
        }
    },
};

const CheckboxLoop = [
    {
        checkLabel: "Original video file added",
        type: "",
    },
    {
        checkLabel: "Reviewed by Admin",
        type: "",
    },
    {
        checkLabel: "Social Media post added",
        type: "check",
    },

    {
        checkLabel: "Support ticket updates ",
        type: "",
    },
    {
        checkLabel: "Tipalti access granted",
        type: "",
    },
];

export default function QcNotificationFilter() {
    const [open, setOpen] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState("");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const [messageby, setMessageby] = React.useState("");

    const handleChange1 = (event) => {
        setMessageby(event.target.value);
    };

    const [messageto, setMessageto] = React.useState("");

    const handleChange2 = (event) => {
        setMessageto(event.target.value);
    };

    return (
        <>
            <Box className={styles.filterNotification}>
                <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    justifyContent="space-between"
                    className={styles.filterHeading}
                >
                    <Button
                        className={styles.btnFilter}
                        onClick={handleClickOpen}
                    >
                        <TableFilterIcon />
                    </Button>
                    <TextField
                        id="outlined-size-normal"
                        placeholder="Search..."
                        InputProps={{
                            startAdornment: (
                                <InputAdornment
                                    position="start"
                                    className={searchValue ? styles.startAdmnt : undefined}
                                >
                                    <img
                                        src={SearchIcon}
                                        width={11.5}
                                        height={11.5}
                                        alt="icon"
                                    />
                                </InputAdornment>
                            ),
                        }}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        sx={
                            searchValue
                                ? {
                                    border: "1px solid #111AE9 !important",
                                    borderRadius: "47px",
                                }
                                : undefined
                        }
                    />
                </Stack>
                <List className={styles.selectMonthList}>
                    <ListItem className={styles.filterToday}>
                        <Link to="#">Today</Link>
                        <Button>
                            <img
                                src={icongrayCross}
                                width={10}
                                height={10}
                                alt="icon"
                            />
                            view all
                        </Button>
                    </ListItem>
                    <ListItem>
                        <Link to="#">Yesterday</Link>
                    </ListItem>
                    <ListItem>
                        <Link to="#">This week</Link>
                    </ListItem>
                    <ListItem>
                        <Link to="#">Last 7 days</Link>
                    </ListItem>
                    <ListItem>
                        <Link to="#">This month</Link>
                    </ListItem>
                    <ListItem>
                        <Link to="#">Last month</Link>
                    </ListItem>
                    <ListItem>
                        <Link to="#">Last 6 months</Link>
                    </ListItem>
                    <ListItem>
                        <Link to="#">This year</Link>
                    </ListItem>
                    <ListItem>
                        <Link to="#">Last year</Link>
                    </ListItem>
                </List>
                <Box className={`${styles.dateRange} commonDateRange`}>
                    <Typography variant="overline">Start date</Typography>
                    <Stack direction="row" flexWrap="wrap" className={styles.monthStacks}>
                        <SelectMonth />
                        <SelectDay />
                        <SelectYear />
                    </Stack>
                </Box>
                <Box className={`${styles.dateRange} commonDateRange`}>
                    <Typography variant="overline">End date</Typography>
                    <Stack direction="row" flexWrap="wrap" className={styles.monthStacks}>
                        <SelectMonth />
                        <SelectDay />
                        <SelectYear />
                    </Stack>
                </Box>
                <Box className={`${styles.dateConfirm} commonDateConfirm`}>
                    <Button>
                        <span>Confirm</span> date range
                    </Button>
                </Box>
            </Box>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "787px",
                        position: "relative",
                    }
                }}
                sx={dialogContainer}
            >
                <DialogContent>
                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} justifyContent={'space-between'} className={styles.filterModalHeader}>
                        <Typography variant='h4'>Filter</Typography>
                        <Button startIcon={<ClearIcon />}>Clear</Button>
                    </Stack>
                    <Box className={styles.filterModalBody}>
                        <Box className={styles.selectGroupStyled}>
                            <Grid
                                container
                                rowSpacing={1.5}
                                columnSpacing={{ xs: 1, sm: 2, lg: 9.5 }}
                            >
                                <Grid item md={6}>
                                    <Box className={styles.formGrpStyled}>
                                        <Stack
                                            direction={"row"}
                                            alignItems={"center"}
                                            flexWrap={"wrap"}
                                            className={styles.labelHeader}
                                        >
                                            <Typography variant='caption'>Message sent by</Typography>
                                            <Button>
                                                <ResetIcon />
                                            </Button>
                                        </Stack>
                                        <CustomSelect
                                            value={messageby}
                                            onChange={handleChange1}
                                            displayEmpty
                                        >
                                            <MenuItem value=""></MenuItem>
                                            <MenuItem value={10}>
                                                Need your reply
                                            </MenuItem>
                                            <MenuItem value={20}>Pending</MenuItem>
                                            <MenuItem value={30}>Resolved</MenuItem>
                                        </CustomSelect>
                                    </Box>
                                </Grid>
                                <Grid item md={6}>
                                    <Box className={styles.formGrpStyled}>
                                        <Stack
                                            direction={"row"}
                                            alignItems={"center"}
                                            flexWrap={"wrap"}
                                            className={styles.labelHeader}
                                        >
                                            <Typography variant='caption'>Note left by</Typography>
                                            <Button>
                                                <ResetIcon />
                                            </Button>
                                        </Stack>
                                        <CustomSelect
                                            value={messageto}
                                            onChange={handleChange2}
                                            displayEmpty
                                        >
                                            <MenuItem value=""></MenuItem>
                                            <MenuItem value={10}>
                                                Need your reply
                                            </MenuItem>
                                            <MenuItem value={20}>Pending</MenuItem>
                                            <MenuItem value={30}>Resolved</MenuItem>
                                        </CustomSelect>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className={styles.checkWrapper}>
                            <Box className={styles.checkboxRows}>
                                <Grid
                                    container
                                    rowSpacing={2.5}
                                    columnSpacing={{ xs: 1, sm: 2, lg: 9.5 }}
                                >
                                    {CheckboxLoop.map((item, index) => {
                                        return (
                                            <Grid key={index} item md={6}>
                                                <Stack
                                                    direction={"row"}
                                                    alignItems={"center"}
                                                    flexWrap={"wrap"}
                                                    className={styles.styledCheck}
                                                >
                                                    <CustomCheckBox
                                                        defaultChecked={
                                                            item?.type === "check"
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <Typography variant="caption">
                                                        {item?.checkLabel}
                                                    </Typography>
                                                </Stack>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Box>
                        </Box>
                    </Box>
                    <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"flex-end"}
                        className={styles.modalFooter}
                    >
                        <Button className={styles.canelBtn}>Cancel</Button>
                        <Button className={styles.filterBtn}>
                            Filter <span>now</span>
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>
        </>

    )
}
